export default {
  ALL: 1,
  APP: 2,
  WEB: 3,
};